import type { ProductNearToLimit } from 'apiConnector/discover/lifeCycle';
import { Section } from 'components/discover/post-trade/life-cycle/section/section-content';
import { FormattedMessage } from 'components/shared/Intl';

import type { LifeCycleItemProps } from './section-container';

import 'components/discover/post-trade/life-cycle/index.css';
import { LifeCycleSectionContainer, lifeCycleApi } from './section-container';

export function WithCapitalBarrierEventSection(props: LifeCycleItemProps) {
  return (
    <LifeCycleSectionContainer
      title="withCapitalBarrierEvent"
      fetchData={lifeCycleApi.fetchWithCapitalBarrierEvent}
      {...props}
    >
      {(product: ProductNearToLimit, index: number) => (
        <Content underlyingList={product.underlyingList} index={index} />
      )}
    </LifeCycleSectionContainer>
  );
}

type BadgeProps = Pick<ProductNearToLimit, 'underlyingList'> & { index: number };

function Content({ underlyingList }: BadgeProps) {
  const hasMultipleUnderlyings = underlyingList && underlyingList.length > 1;
  const isMonoUnderlyingWithHit = underlyingList?.length === 1 && underlyingList[0].capitalLimitHit;

  return hasMultipleUnderlyings ? (
    <Section.Provider>
      <Section.Header />
      <Section.Overlay>
        <table className="table table-sm table-borderless mb-0 fs-6">
          <Section.TableHeader
            translationKeys={['discover.lifeCycle.bloomberg', 'discover.lifeCycle.capitalLimitHit']}
          />

          <tbody className="text-secondary">
            {underlyingList.map((underlying, underlyingIndex) => (
              <tr key={underlyingIndex}>
                <Section.TableCell>{underlying.bloombergCode}</Section.TableCell>
                <Section.TableCell>
                  {underlying.capitalLimitHit ? (
                    <Section.Hit />
                  ) : (
                    <Section.Badge>
                      <FormattedMessage id="discover.lifeCycle.unHit" defaultMessage="UnHit" />
                    </Section.Badge>
                  )}
                </Section.TableCell>
              </tr>
            ))}
          </tbody>
        </table>
      </Section.Overlay>
    </Section.Provider>
  ) : (
    <>
      {isMonoUnderlyingWithHit ? (
        <Section.Hit />
      ) : (
        <Section.Badge>
          <FormattedMessage id="discover.lifeCycle.unHit" defaultMessage="UnHit" />
        </Section.Badge>
      )}
    </>
  );
}
